// LEGACY FILE - STUB COMPONENT
// EdgeDocsCore system replaced by ClientFirst implementation
// This stub prevents TypeScript compilation errors

import React from 'react';

export const EdgedocsCanvasViewer: React.FC<any> = () => {
  return (
    <div className="p-4 text-center text-gray-500">
      <p>Legacy EdgeDocsCore Canvas Viewer</p>
      <p>Replaced by ClientFirst implementation</p>
    </div>
  );
};

